import { render } from "./WebRTCcall.vue?vue&type=template&id=178c727e&scoped=true"
import script from "./WebRTCcall.vue?vue&type=script&lang=js"
export * from "./WebRTCcall.vue?vue&type=script&lang=js"

import "./WebRTCcall.vue?vue&type=style&index=0&id=178c727e&lang=css"
import "./WebRTCcall.vue?vue&type=style&index=1&id=178c727e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178c727e"]])

export default __exports__